export default __webpack_public_path__ + "static/media/stocks.f378032d.svg";